import { useStores } from '../stores/useStores';
import { HIGH_PRESSURE_THRESHOLDS_NUM } from '../utils';

export const useUpdateTrappingZoneHighPressure = () => {
  const { traplogStore } = useStores();

  let highPressureThresholdMetCount = 0;
  const updateTrappingZoneHighPressure = (
    trappingZone,
    trappingResult,
    amountThresholdsMet,
    accumulationThresholdsMet,
    averageThresholdMet
  ) => {
    const highPressureThresholdMet =
      !trappingResult.sprayed &&
      (amountThresholdsMet > 0 ||
        accumulationThresholdsMet > 0 ||
        averageThresholdMet);
    const isHighPressure = trappingZone?.high_pressure;
    if (highPressureThresholdMet) {
      highPressureThresholdMetCount++;
    }
    // Only update the trapping zone high pressure when the selected insect is Codling Moth,
    // and the high pressure threshold has been reached.
    if (
      traplogStore.selectedInsectGroup.short_name === 'CM' &&
      highPressureThresholdMetCount >= HIGH_PRESSURE_THRESHOLDS_NUM &&
      !isHighPressure
    ) {
      traplogStore.updateTrappingZoneHighPressure(trappingZone.id, true);
    }
    return highPressureThresholdMetCount;
  };

  return { updateTrappingZoneHighPressure };
};
